export default __webpack_public_path__ + "static/Mercedes-Benz Sprinter Classic-2c94bbb19049e36dfca263c3b37ec3b9.jpg";